export default __webpack_public_path__ + "static/media/frasersTower.jpg?.bf61e5d6";